import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/common.css'
// 导入iconfont
import './assets/iconfont/iconfont.css'

Vue.use(Vant);

import "lib-flexible"

// 导入请求
import api from './api/index'
Vue.prototype.$api = api  // 将api挂入到vue原型上

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
